import React from 'react';

const TermsAndConditions = () => {
    return (
        <div className="container mt-5">
            <h1 className="text-center">Terms and Conditions ("Terms of Use")</h1>
            <p className="text-center">
                For Clients and End-Users of the PerPal Platform
            </p>
            <section>
                <h2>1. Introduction</h2>
                <p>
                    These Terms of Use set forth the rights and responsibilities between 12157152 CANADA LTD ("we", "us", or "our"), the Clients who operate branded instances of the PerPal Platform ("Clients" or "Operators"), and the individuals who register or use those instances ("you", "your", or "user").
                </p>
                <p>
                    By using a website or platform operated by a Client of the PerPal Platform, or by registering an account on such a site (an "Account"), you agree to be bound by these Terms of Use and our Privacy Policy.
                </p>
            </section>

            <section>
                <h2>2. Platform Structure and Responsibilities</h2>
                <p>
                    12157152 CANADA LTD operates and licenses the PerPal Platform, a Software-as-a-Service (SaaS) that enables Clients to manage their own foreign exchange and money service operations online. We do not directly provide or intermediate financial transactions, nor do we handle client funds or engage in money transmission activities.
                </p>
                <p>
                    Each Client is an independent operator of its own branded instance of the PerPal Platform and is solely responsible for compliance with applicable laws, user verification (KYC), financial operations, service delivery, and consumer protection within its jurisdiction.
                </p>
                <p>
                    End-users who register and transact on a Client's instance are bound by these Terms of Use, which govern their interaction with the platform.
                </p>
            </section>

            <section>
                <h2>3. Role of PerPal (12157152 CANADA LTD)</h2>
                <ul>
                    <li>12157152 CANADA LTD provides the technological infrastructure and platform tools but does not:</li>
                    <ul>
                        <li>Offer financial services.</li>
                        <li>Facilitate, process, or guarantee any user payments or transactions.</li>
                        <li>Act as an agent, broker, or trustee for any end-user or Client.</li>
                        <li>Hold or custody any user funds.</li>
                    </ul>
                    <li>
                        PerPal is not responsible for actions, omissions, or policies implemented by any Client.
                    </li>
                </ul>
            </section>

            <section>
                <h2>4. Role of Clients</h2>
                <p>Clients are businesses using the PerPal Platform under their own trade names. Each Client is solely responsible for:</p>
                <ul>
                    <li>Their registration as a money service business (if applicable).</li>
                    <li>Compliance with anti-money laundering (AML) and know-your-customer (KYC) laws.</li>
                    <li>Providing disclosures, pricing, customer service, and regulatory documentation to end-users.</li>
                    <li>Handling all aspects of transactions and user account management.</li>
                </ul>
            </section>

            <section>
                <h2>5. Use of the Platform</h2>
                <p>
                    Users may only access and use the platform if they meet the eligibility requirements set by the Client. Users must:
                </p>
                <ul>
                    <li>Be at least the age of majority in their jurisdiction.</li>
                    <li>Provide accurate and up-to-date registration information.</li>
                    <li>Use their account for lawful and personal purposes only.</li>
                    <li>Keep credentials secure and notify the Client immediately of any unauthorized access or suspicious activity.</li>
                </ul>
                <p>
                    Each user is solely responsible for maintaining the confidentiality of their account credentials. The Client will never request your password by email, phone, or text. If you suspect unauthorized access or unusual activity in your account, you must contact your service provider (the Client) through the support channels provided by them.
                </p>
            </section>

            <section>
                <h2>6. Prohibited Use</h2>
                <p>
                    The PerPal Platform may not be used to facilitate or support any of the following:
                </p>
                <ul>
                    <li>Illegal, fraudulent, or unauthorized transactions.</li>
                    <li>Sanctioned entities or individuals.</li>
                    <li>Activities involving weapons, narcotics, or obscenity.</li>
                    <li>Transactions prohibited by law in the applicable jurisdiction.</li>
                </ul>
                <p>We reserve the right to suspend access to the platform for suspected violations.</p>
            </section>

            <section>
                <h2>7. Intellectual Property</h2>
                <p>
                    All software, trademarks, content, and systems used to power the PerPal Platform are owned by or licensed to 12157152 CANADA LTD. Clients and users may not duplicate, reverse engineer, or modify the software or materials without express written consent.
                </p>
            </section>

            <section>
                <h2>8. Availability and Modifications</h2>
                <p>
                    We do not guarantee that the platform will be available at all times or free from interruptions. Maintenance, updates, or outages may occur. We may modify, suspend, or terminate the platform or these Terms at any time.
                </p>
            </section>

            <section>
                <h2>9. Limitation of Liability</h2>
                <p>
                    12157152 CANADA LTD is not responsible for any losses, claims, damages, or liabilities arising from:
                </p>
                <ul>
                    <li>The actions or omissions of any Client.</li>
                    <li>Service errors, transaction failures, or technical issues beyond our control.</li>
                    <li>User misuse, account compromise, or failure to comply with security practices.</li>
                </ul>
                <p>
                    To the maximum extent permitted by law, our liability to any user is limited to the direct damages caused by our own negligence, and in no case shall exceed $10 CAD.
                </p>
            </section>

            <section>
                <h2>10. Disclaimer of Warranties</h2>
                <p>
                    The platform is provided "as is" and "as available." We disclaim all warranties of any kind, express or implied, including merchantability, fitness for a particular purpose, and non-infringement.
                </p>
            </section>

            <section>
                <h2>11. Governing Law</h2>
                <p>These Terms are governed by the laws of the Province of Ontario and the federal laws of Canada. Any disputes must be resolved in the courts of Ontario.</p>
            </section>

            <section>
                <h2>12. Entire Agreement</h2>
                <p>
                    These Terms of Use constitute the complete agreement between you and 12157152 CANADA LTD with respect to your use of the platform. If a conflict exists between these Terms and any Client-provided documentation, these Terms will prevail as to the platform provider’s (12157152 CANADA LTD’s) role and liability.
                </p>
            </section>
        </div>
    );
};

export default TermsAndConditions;